exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".PasswordForm__InputWithIcon__1w5MZm {\n  margin-bottom: 10px;\n}\n.PasswordForm__InputWithIcon__1w5MZm:last-child {\n  margin-bottom: 0;\n}\n", ""]);

// exports
exports.locals = {
	"InputWithIcon": "PasswordForm__InputWithIcon__1w5MZm"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--2-1!./node_modules/postcss-loader/src??ref--2-2!./node_modules/stylus-loader!./web_modules/trustar/components/PasswordForm.styl
// module id = 3585
// module chunks = 39